import React, {FC} from 'react';
import {SetStatePropsType} from "@baseTypes/base";
import {SxType} from "@baseTypes/sx/sxTypes";
import MenuBarCustom from "@ui/menuBarCustom/MenuBarCustom";
import {getDateStartEndTemplateByKey} from "@ui/datePicker/helpers/helpers";
import {DATE_PICKER_DATE_START_END_ACTIONS} from "@ui/datePicker/constants";
import {Chip, Stack} from "@mui/material";
import {useTranslation} from "react-i18next";
import moment from 'moment'
import IconButtonCustom from "@ui/buttons/iconButtonCustom/IconButtonCustom";
import ColumnsSvg from "@resource/svg/ColumnsSvg";
import {sx} from './sx'

interface IProps {
    dateStart: string,
    dateEnd: string,
    format?: string,
    onChangeDateStart: SetStatePropsType<string>,
    onChangeDateEnd: SetStatePropsType<string>,
    disabled?: boolean,
    sx?: SxType,
    actionKeys?: string[],
    closeMenuFn?: () => void
}


const Template: FC<IProps> = ({
                                  dateStart,
                                  dateEnd,
                                  onChangeDateStart,
                                  onChangeDateEnd,
                                  format,
                                  sx: sxProps = {},
                                  actionKeys,
                                  closeMenuFn,
                              }) => {
    const {t} = useTranslation()

    const currentActions = !actionKeys || !actionKeys?.length ? DATE_PICKER_DATE_START_END_ACTIONS : DATE_PICKER_DATE_START_END_ACTIONS.filter((item) => actionKeys.includes(item.value))

    const list = currentActions.map((item) => {
        const {dateStart, dateEnd} = getDateStartEndTemplateByKey(item?.value)
        const onClick = () => {
            onChangeDateStart(moment(dateStart).format(format))
            onChangeDateEnd(moment(dateEnd).format(format))
            closeMenuFn && closeMenuFn()
        }
        return (
            <Chip
                key={item?.value}
                size="small"
                onClick={onClick}
                label={t(item?.label)}
                sx={sx.item}
                color={'info'}
            />
        )
    })

    return (
        <Stack
            gap={1}
        >
            {list}
        </Stack>
    );
};


const DateStartEndTemplate: FC<IProps> = ({
                                              dateStart,
                                              dateEnd,
                                              onChangeDateStart,
                                              onChangeDateEnd,
                                              format,
                                              sx: sxProps = {},
                                              actionKeys,
                                              disabled,
                                          }) => {


    return (
        <MenuBarCustom
            disabled={disabled}
            button={<IconButtonCustom
                disabled={disabled}
                sx={sx.icon}
            >
                <ColumnsSvg/>
            </IconButtonCustom>}
            buttonClose
        >
            {({closeMenuFn}) => (<Template
                dateStart={dateStart}
                onChangeDateEnd={onChangeDateEnd}
                dateEnd={dateEnd}
                onChangeDateStart={onChangeDateStart}
                format={format}
                actionKeys={actionKeys}
                closeMenuFn={closeMenuFn}
            />)}
        </MenuBarCustom>
    );
};

export default DateStartEndTemplate;